var fails = require('./_fails');

module.exports = function(method, arg){
  return !!method && fails(function(){
    arg ? method.call(null, function(){}, 1) : method.call(null);
  });
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_strict-method.js
 ** module id = 37
 ** module chunks = 1
 **/